import moment from "moment";

import { ProductLifetimeStatsRequestParams } from "../../apis";

export enum ProductStatsRange {
  Month = "month",
  Year = "year",
  AllTime = "allTime",
  Custom = "custom"
}

export const PRODUCT_STATS_RANGE_TABS = [
  { label: "Month", value: ProductStatsRange.Month },
  { label: "Year", value: ProductStatsRange.Year },
  { label: "All time", value: ProductStatsRange.AllTime },
  { label: "Custom", value: ProductStatsRange.Custom }
];

const formatFrom = (date: Date) =>
  `${moment(date).format("YYYY-MM-DD")}T00:00:00.000Z`;

const formatTo = (date: Date) =>
  `${moment(date).format("YYYY-MM-DD")}T23:59:59.999Z`;

export const getRangeParams = (
  range: ProductStatsRange,
  customRange: [Date, Date]
): ProductLifetimeStatsRequestParams => {
  if (range === ProductStatsRange.AllTime) {
    return { breakdownBy: "Month" };
  }

  if (range === ProductStatsRange.Year) {
    return {
      from: formatFrom(moment().subtract(1, "year").toDate()),
      to: formatTo(new Date()),
      breakdownBy: "Month"
    };
  }

  if (range === ProductStatsRange.Custom) {
    return {
      from: formatFrom(customRange[0]),
      to: formatTo(customRange[1]),
      breakdownBy: "Day"
    };
  }

  return {
    from: formatFrom(moment().subtract(1, "month").toDate()),
    to: formatTo(new Date()),
    breakdownBy: "Day"
  };
};
